module.exports = {"430203001":"贺家土街道","430203002":"建设街道","430203003":"建宁街道","430203004":"董家段街道","430203005":"庆云街道","430203006":"枫溪街道","430203007":"龙泉街道","430203100":"白关镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430203.json
// module id = 1939
// module chunks = 0